import { render, staticRenderFns } from "./MemberAreaCategories.vue?vue&type=template&id=cbcfa466&scoped=true&"
import script from "./MemberAreaCategories.vue?vue&type=script&lang=js&"
export * from "./MemberAreaCategories.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaCategories.vue?vue&type=style&index=0&id=cbcfa466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcfa466",
  null
  
)

export default component.exports